// WorkspaceSummary — the right-side contextual panel showing live-computed values.
// Each chip updates as the form changes (margin, stock status, variant count, etc.).

import { Chip, Card, CardContent, Stack, Typography } from '@mui/material';

export type SummaryChip = { label: string; value: string; tone?: 'default' | 'success' | 'warning' | 'error' };

export function WorkspaceSummary({ chips }: { chips: SummaryChip[] }) {
  if (!chips.length) return null;
  return (
    <Card variant="outlined" sx={{ position: 'sticky', top: 16 }}>
      <CardContent sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
          Summary
        </Typography>
        <Stack spacing={1.5}>
          {chips.map((chip, i) => (
            <Stack key={i} direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2" color="text.secondary">
                {chip.label}
              </Typography>
              <Chip
                size="small"
                label={chip.value}
                color={chip.tone === 'success' ? 'success' : chip.tone === 'warning' ? 'warning' : chip.tone === 'error' ? 'error' : 'default'}
                variant={chip.tone && chip.tone !== 'default' ? 'filled' : 'outlined'}
                sx={{ fontWeight: 600 }}
              />
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}
